import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import i18n from 'i18next';
import { get } from 'lodash';
import { initReactI18next, useTranslation } from 'react-i18next';
import { resources as libsResources } from '../locales';
var defaultLanguage = 'en';
var resources = libsResources;

var deepMerge = function deepMerge(target, source) {
  for (var key in source) {
    if (typeof source[key] === 'object' && source[key] !== null && typeof target[key] === 'object') {
      deepMerge(target[key], source[key]); // 递归合并子对象
    } else {
      target[key] = source[key]; // 直接赋值
    }
  }

  return target;
};
/**
 * init i18n
 * @param options
 */


export var initI18n = function initI18n(options) {
  resources = deepMerge(resources, options.resources || {});
  i18n.use(initReactI18next).init(_objectSpread({
    lng: defaultLanguage,
    // default language
    fallbackLng: defaultLanguage,
    // fallback language when language doesn't exist
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default

    },
    react: {}
  }, Object.assign({}, options || {}, {
    resources: resources
  })));
};
/**
 * get current language function
 */

export var getLanguage = function getLanguage() {
  var language = i18n.language || defaultLanguage;
  return language;
};
/**
 * get current language hook
 */

export var useGetLanguage = function useGetLanguage() {
  var _useTranslation = useTranslation(),
      i18n = _useTranslation.i18n;

  var language = i18n.language || defaultLanguage;
  return language;
};
/**
 * switch language function
 */

export var changeLanguage = function changeLanguage(lng) {
  if (lng) {
    i18n.changeLanguage(lng);
  }
};
/**
 * switch language hook
 */

export var useChangeLanguage = function useChangeLanguage(lng) {
  var _useTranslation2 = useTranslation(),
      i18n = _useTranslation2.i18n;

  i18n.changeLanguage(lng);
};
export var getLocalTranslation = function getLocalTranslation() {
  var t = i18n.t;

  if (!i18n.isInitialized) {
    return {
      $t: function $t(key) {
        var _resources, _resources$defaultLan;

        var ary = key.split(':');
        var nsName = ary.length > 1 ? ary[0] : 'kit';
        var keyName = ary.length > 1 ? ary[1] : ary[0];
        var keyNames = keyName.split('.');
        var val = (_resources = resources) === null || _resources === void 0 ? void 0 : (_resources$defaultLan = _resources[defaultLanguage]) === null || _resources$defaultLan === void 0 ? void 0 : _resources$defaultLan[nsName];
        keyNames.forEach(function (key) {
          var _val;

          val = (_val = val) === null || _val === void 0 ? void 0 : _val[key];
        });
        return val || key;
      }
    };
  }

  return {
    $t: t
  };
};
/**
 * useLocalTranslation hook
 * @returns
 */

export var useLocalTranslation = function useLocalTranslation() {
  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  if (!i18n.isInitialized) {
    return {
      $t: function $t(key) {
        var ary = key.split(':');
        var nsName = ary.length > 1 ? ary[0] : 'kit';
        var keyName = ary.length > 1 ? ary[1] : ary[0];
        return get(resources, [defaultLanguage, nsName].concat(_toConsumableArray(keyName === null || keyName === void 0 ? void 0 : keyName.split('.')))) || key;
      }
    };
  }

  return {
    $t: t
  };
};
export var getProjecti18n = function getProjecti18n() {
  return i18n;
};
export default i18n;